import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';

import { CompanyStore } from '../store/company.store';

export const CasinoLiveGuard: CanActivateFn = () => {
  const viewConfig = inject(CompanyStore).viewConfigSignal();
  const company = inject(CompanyStore).companySignal();
  if (viewConfig?.live_casino_screen && 'enable' in viewConfig?.live_casino_screen) {
    return viewConfig?.live_casino_screen?.enable;
  } else {
    return company?.live_casino;
  }
};
